/*
 * @Author: libo 
 * @Date: 2020-11-19 10:58:20 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-06-10 17:05:40
 */

<template>
    <a-modal
      :width="modalWidth"
      :visible="visible"
      :title="title"
      :maskClosable="maskClosable"
      destroyOnClose
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel"
      :cancelText="$t('关闭')"
      wrapClassName="ant-modal-cust-warp"
      >
      <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
      </template>
      <div class="form-contain">
        <a-divider orientation="left">{{ $t('基本数据') }}
          <span>
            ({{ $t('表类型') }}: {{model.mtCodeName}})
          </span>
        </a-divider>
        <a-form-model ref="taskModal" :model="taskModel" :rules="taskRules" :colon="false" layout="vertical">
          <a-row :gutter="24">
            <a-col :span="12" v-if="model.batchType === 1">
              <a-form-model-item :label="$t('所选区域')">
                <a-input-search style="width: 90%" :placeholder="$t('点击选择区域')" v-model="checkedAreaNameString" readOnly
                  @search="onSearchArea">
                  <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
                </a-input-search>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="model.batchType === 2">
              <a-form-model-item :label="$t('所选区域')">
                <a-textarea readOnly v-model="model.meterIdList" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="model.batchType === 3">
              <a-form-model-item :label="$t('导入文件')">
                <a-upload name="file"
                  :multiple="false"
                  accept=".xls"
                  :fileList="fileList"
                  :headers="tokenHeader"
                  :beforeUpload="beforeUpload"
                  :remove="handleRemove">
                  <a-button>
                    <a-icon type="upload" />
                    {{ $t('选择导入文件') }}
                  </a-button>
                </a-upload>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('任务名称')" prop="taskName">
                <a-input :placeholder="$t('请输入任务名称')" v-model="taskModel.taskName"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :xl="24" :lg="24" :md="24" :sm="24">
              <a-form-model-item :label="$t('描述')" prop="remark">
                <a-textarea v-model="taskModel.remark" rows="2" :placeholder="$t('请输入备注')" style="width:100%" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <a-layout id="components-layout-demo-top-side">
          <a-layout-content>
            <a-layout style="padding: 24px 0; background: #fff">
              <!--
              <a-layout-sider width="230" style="background: #fff">
                <a-menu mode="inline" v-model="commandKey" :open-keys="openKeys" style="height:450px;overflow-y: scroll;overflow-x: hidden;" @openChange="onOpenChange">
                  <a-sub-menu key="sub1">
                    <span slot="title"><span>读命令</span></span>
                    <a-menu-item v-for="item in readCommandList" :key="item.key" :value="item.key" :label="item.title" @click="handleClick">
                      {{item.title}}
                    </a-menu-item>
                  </a-sub-menu>
                  <a-sub-menu key="sub2">
                    <span slot="title"><span>写命令</span></span>
                    <a-menu-item v-for="item in writeCommandList" :key="item.key" :value="item.key" :label="item.title" @click="handleClick">
                      {{item.title}}
                    </a-menu-item>
                  </a-sub-menu>
                </a-menu>
              </a-layout-sider>
              -->
              {{ $t('选择命令') }}
              <a-select style="width: 200px" v-model="commandKey" @change="handleClick" :placeholder="$t('选择命令')">
                <a-select-opt-group>
                  <span slot="label">{{ $t('读命令') }}</span>
                  <a-select-option v-for="item in readCommandList" :key="item.key" :value="item.key">
                    {{ $t(item.title) }}
                  </a-select-option>
                </a-select-opt-group>
                <a-select-opt-group :label="$t('写命令')">
                  <a-select-option v-for="item in writeCommandList" :key="item.key" :value="item.key">
                    {{ $t(item.title) }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
              <a-layout-content :style="{ padding: '0 24px',margin: '24px 0' }">
                <!-- 读取表具信息 -->
                <a-form-model v-if="commandKey == 1" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取表具信息') }}</h2><a-divider />
                </a-form-model>
                <!-- 校时 -->
                <a-form-model v-if="commandKey == 2" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('校时') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="14">
                  <a-form-model-item :label="$t('校准时间')" prop="timings" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-date-picker show-time v-model="formModel.timings"  :placeholder="$t('请输入日期时间')" @change="timing" @ok="onOk" style="width: 150%"/>
                  </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 写表号 -->
                <a-form-model v-if="commandKey == 3" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                <h2>{{ $t('写表号') }}</h2><a-divider />
                <a-row :gutter="16">
                  <a-col :span="14">
                    <a-form-model-item  :label="$t('新表号')" prop="newMeterId" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.newMeterId"  :placeholder="$t('请输入新表号')" style="width:150%"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                </a-form-model>
                <!-- 读表号 -->
                <a-form-model v-if="commandKey == 4" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读表号') }}</h2><a-divider />
                </a-form-model>
                <!-- 强制开关阀 -->
                <a-form-model v-if="commandKey == 5" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('强制开关阀') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="14">
                      <a-form-model-item :label="$t('控制类型')" prop="valveOperate" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.valveOperate" :placeholder="$t('请选择控制类型')" style="width: 150%">
                          <a-select-option v-for="item in randomnessList"  :value="item.key" :key="item.key" :label="$t(item.title)">
                            {{ $t(item.title) }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 修改运行密匙 -->
                <a-form-model v-if="commandKey == 6" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                <h2>{{ $t('修改运行密匙') }}</h2><a-divider />
                <a-row :gutter="16">
                  <a-col :span="19">
                    <a-form-model-item  :label="$t('新运行密匙1')" prop="newKey1" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.newKey1" placeholder="" style="width:100%;"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="19">
                    <a-form-model-item  :label="$t('新运行密匙2')" prop="newKey2" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.newKey2" placeholder="" style="width:100%"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="19">
                    <a-form-model-item  :label="$t('新运行密匙3')" prop="newKey3" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.newKey3" placeholder="" style="width:100%"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="19">
                    <a-form-model-item  :label="$t('新运行密匙4')" prop="newKey4" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.newKey4" placeholder="" style="width:100%"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                </a-form-model>
                <!-- 配置上报参数 -->
                <a-form-model v-if="commandKey == 7" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('配置表上报参数') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="18">
                      <a-form-model-item :label="$t('上报周期')" prop="formModel" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select v-model="reportedperiod" style="width: 47%" @change="handleperiodChange">
                        <a-select-option v-for="period in periodData" :key="period.key" :value="period.key">
                          {{ $t(period.title) }}
                        </a-select-option>
                      </a-select>
                      <a-select v-model="secondcycle" style="width: 50%;margin-left:5px;" @change="handleChange">
                        <a-select-option v-for="cycle in cities" :key="cycle.key" :value="cycle.key">
                          {{ cycle.title }}
                        </a-select-option>
                      </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('起始时间')" prop="startDate" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select v-model="timeSecondcycle" style="width: 40%;" @change="handleChangetime">
                        <a-select-option v-for="time in timeCities" :key="time.key" :value="time.key">
                          {{ $t(time.title) }}
                        </a-select-option>
                      </a-select>
                      <a-time-picker v-model="formModel.startTime" format="HH:mm:ss"  style="width:57%;margin-left:5px;" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('最大失联次数')" prop="reportNum" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.reportNum" :placeholder="$t('整数')" style="width: 100%;"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('错峰间隔(秒)')" prop="reportInterval" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.reportInterval" :placeholder="$t('整数')" style="width: 100%;"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('重试次数')" prop="retryNum" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.retryNum" :placeholder="$t('整数')" style="width: 100%;"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('重试轮数')" prop="retryRounds" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.retryRounds" :placeholder="$t('整数')" style="width: 100%;"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('工作模式')" prop="mode" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.mode" style="width: 100%">
                          <a-select-option v-for="item in workpatternList"  :value="item.key" :key="item.key" :label="$t(item.title)">
                            {{ $t(item.title) }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!--读取表上报参数-->
                <a-form-model v-if="commandKey == 8" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取表上报参数') }}</h2><a-divider />
                </a-form-model>
                <!-- 配置表网络参数 -->
                <a-form-model v-if="commandKey == 9" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                <h2>{{ $t('配置表网络参数') }}</h2><a-divider />
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-model-item  :label="$t('IP')"  prop="ip" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.ip" placeholder="" style="width:150%;"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item  :label="$t('端口号')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.port" placeholder="" style="width:150%"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                </a-form-model>
                <!-- 读取表网络参数 -->
                <a-form-model v-if="commandKey == 10" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取网络参数') }}</h2><a-divider />
                </a-form-model>
                <!-- 配置表工作参数 -->
                <a-form-model v-if="commandKey == 11" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                <h2>{{ $t('配置表工作参数') }}</h2><a-divider />
                <a-row :gutter="16">
                  <a-col :span="18">
                    <a-form-item  :label="$t('最大流量')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.maxFlow" placeholder="" :suffix="$t('秒')" style="width:100%;"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="18">
                    <a-form-item :label="$t('是否带阀')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="formModel.hasValve" style="width:100%" :placeholder="$t('请选择阀门状态')">
                      <a-select-option :value="0">
                        {{ $t('无阀') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('有阀') }}
                      </a-select-option>
                    </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="18">
                    <a-form-item  :label="$t('干扰持续时间')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.disturbTime" placeholder="" :suffix="$t('分')"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="18">
                    <a-form-item :label="$t('干扰后是否关阀')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="formModel.disturbIsCloseValve" style="width:100%" :placeholder="$t('请选择阀门状态')">
                      <a-select-option :value="0">
                        {{ $t('不关阀') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('关阀') }}
                      </a-select-option>
                    </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="18">
                    <a-form-item  :label="$t('缺电后关阀时间')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.lowPowerIsCloseValve" placeholder="" :suffix="$t('分')" style="width:100%"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                </a-form-model>
                <!-- 读取表工作参数 -->
                <a-form-model v-if="commandKey == 12" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取表工作参数') }}</h2><a-divider />
                </a-form-model>
                <!-- 读取表历史数据 -->
                <a-form-model v-if="commandKey == 13" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取表历史数据') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="18">
                  <a-form-model-item :label="$t('起始冻结日期')" prop="randomness" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-date-picker v-model="formModel.startDate" :placeholder="$t('请输入起始冻结日期')" @change="timing" @ok="onOk" style="width: 120%"/>
                  </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 读取模组IMEI号 -->
                <a-form-model v-if="commandKey == 14" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取模组IMEI号') }}</h2><a-divider />
                </a-form-model>
                <!-- 读取模组版本号 -->
                <a-form-model v-if="commandKey == 15" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取模组版本号') }}</h2><a-divider />
                </a-form-model>
                <!-- 读取模组状态 -->
                <a-form-model v-if="commandKey == 16" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取模组状态') }}</h2><a-divider />
                </a-form-model>
                <!-- 读取SIM卡号 -->
                <a-form-model v-if="commandKey == 17" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取SIM卡号') }}</h2><a-divider />
                </a-form-model>
                <!-- 表端自检功能 -->
                <a-form-model v-if="commandKey == 18" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('表端自检功能') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="14">
                      <a-form-model-item :label="$t('自检内容')" prop="checkContent" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.checkContent" style="width: 150%">
                          <a-select-option v-for="item in selfCheckingContentList"  :value="item.key" :key="item.key" :label="$t(item.title)">
                            {{ $t(item.title) }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 读取最近10次阀门动作原因 -->
                <a-form-model v-if="commandKey == 19" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取最近10次阀门动作原因') }}</h2><a-divider />
                </a-form-model>
                <!-- 清除表端故障 -->
                <a-form-model v-if="commandKey == 20" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('清除表端故障') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="14">
                      <a-form-model-item :label="$t('清除类型')" prop="clearType" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.clearType" style="width: 150%">
                          <a-select-option v-for="item in clearTypeList"  :value="item.key" :key="item.key" :label="$t(item.title)">
                            {{ $t(item.title) }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 模块初始化配置 -->
                <a-form-model v-if="commandKey == 21" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                <h2>{{ $t('模块初始化配置') }}</h2><a-divider />
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item  :label="$t('表底数')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.meterData" :placeholder="$t('范围:0.01-999999')" suffix="m³" style="width:150%;"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-model-item :label="$t('脉冲系数')" prop="pulseParam" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.pulseParam" style="width: 150%">
                          <a-select-option v-for="item in pulseFactorList"  :value="item.key" :key="item.key" :label="$t(item.title)">
                            {{ $t(item.title) }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item  :label="$t('剩余金额')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="formModel.remainMoney" placeholder="" :suffix="$t('元')" style="width:150%"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                </a-form-model>
                <!-- 读取程序版本信息 -->
                <a-form-model v-if="commandKey == 22" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取程序版本信息') }}</h2><a-divider />
                </a-form-model>
                <!-- 读取最近10次联网失败原因 -->
                <a-form-model v-if="commandKey == 23" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取最近10次联网失败原因') }}</h2><a-divider />
                </a-form-model>
                <!-- 读取最近10次表端故障原因 -->
                <a-form-model v-if="commandKey == 24" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取最近10次表端故障原因') }}</h2><a-divider />
                </a-form-model>
                <!-- 读取表端最近10次磁干扰故障 -->
                <a-form-model v-if="commandKey == 25" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('读取表端最近10次磁干扰故障') }}</h2><a-divider />
                </a-form-model>
              </a-layout-content> 
            </a-layout>
          </a-layout-content>
        </a-layout>
        <!--
        <a-row>
          <a-form-model ref="formTaskModel" :model="formTaskModel" :rules="taskRules" :colon="false">
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-model-item  label="备注" prop="remark" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea v-model="formTaskModel.remark"  placeholder="请输入备注信息" style="width:100%"></a-textarea>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-row>
        -->
        <a-row>
          <a-col :span="7">
          </a-col>
          <a-col :span="8">
            <a-button type="primary" block size="large" @click="handleSubmit">
              {{ $t('加入命令队列') }}
            </a-button>
          </a-col>
        </a-row>
      </div>
      <area-window ref="areaWindow" @ok="modalAreaFormOk" :checkStrictly="true"></area-window>
    </a-modal>
</template>

<script>
import i18n from '@/i18n'
  import { postAction ,putAction } from '@/api/manage'
  import { isNull,isUndefinedAndNull } from '@/utils/validate'
  import {paramsToFormData} from '@/utils/util'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import moment from 'moment'
  import { USER_AUTH} from "@/store/mutation-types"
  import DetailList from '@/components/tools/DetailList'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import Vue from 'vue'
  // 引入搜索区域弹出框的组件
  import areaWindow from '@/views/system/modules/areaWindow'
  const DetailListItem = DetailList.Item
  import {queryAreaTreeList} from '@/api/api'
  const originalReadCommandList = [
    {key: 1, title: i18n.t('读取表具信息')},
    {key: 4, title: i18n.t('读表号')},
    {key: 8, title: i18n.t('读取表上报参数')},
    {key: 10, title: i18n.t('读取表网络参数')},
    {key: 12, title: i18n.t('读取表工作参数')},
    {key: 13, title: i18n.t('读取表历史数据')},
    {key: 14, title: i18n.t('读取模组IMEI号')},
    {key: 15, title: i18n.t('读取模组版本号')},
    {key: 16, title: i18n.t('读取模组状态')},
    {key: 17, title: i18n.t('读取SIM卡号')},
    {key: 19, title: i18n.t('读取最近10次阀门动作原因')},
    {key: 22, title: i18n.t('读取程序版本信息')},
    {key: 23, title: i18n.t('读取最近10次联网失败原因')},
    {key: 24, title: i18n.t('读取最近10次表端故障原因')},
    {key: 25, title: i18n.t('读取表端最近10次磁干扰故障')},
  ]
  const originalWriteCommandList = [
    {key: 2, title: i18n.t('校时')},
    {key: 3, title: i18n.t('写表号')},
    {key: 5, title: i18n.t('强制开关阀')},
    {key: 6, title: i18n.t('修改运行密匙')},
    {key: 7, title: i18n.t('配置表上报参数')},
    {key: 9, title: i18n.t('配置表网络参数')}, 
    {key: 11, title: i18n.t('配置表工作参数')},
    {key: 18, title: i18n.t('表端自检功能')},
    {key: 20, title: i18n.t('清除表端故障')},
    {key: 21, title: i18n.t('模块初始化配置')},
  ]
  const randomnessList = [
    {key: 'A1', title: i18n.t('强制开阀')},
    {key: 'A2', title: i18n.t('强制关阀')},
    {key: 'A3', title: i18n.t('取消强制')},
    {key: 'A4', title: i18n.t('开阀')},
    {key: 'A5', title: i18n.t('关阀')}
  ]
  const workpatternList = [
    {key: '01', title: i18n.t('调试模式')},
    {key: '02', title: i18n.t('用户模式')},
  ]
  const selfCheckingContentList = [
    {key: '0', title: i18n.t('只检测阀门')},
    {key: '1', title: i18n.t('全检')}
  ]
  const pulseFactorList = [
    {key: '0.001', title: i18n.t('0.001(1升)')},
    {key: '0.01', title: i18n.t('0.01(10升)')},
    {key: '0.1', title: i18n.t('0.1(100升)')},
    {key: '1', title: i18n.t('1(1000升)')},
  ]
  const clearTypeList = [
    {key: '0', title: i18n.t('不清除故障')},
    {key: '1', title: i18n.t('清除故障')},
    {key: '2', title: i18n.t('清除外接EEPROM内的数据')},
    {key: '3', title: i18n.t('清除表端数据')},
  ]
  const periodData = [
    {key: 0, title:i18n.t('天')},
    {key: 1, title:i18n.t('月')},
    {key: 2, title:i18n.t('周')},
    {key: 3, title:i18n.t('时')},
    {key: 4, title:i18n.t('分')}
  ]
  const cycleData = {
    0: [
        {key: 1, title:'1'},
        {key: 2, title:'2'},
        {key: 3, title:'3'},
        {key: 4, title:'4'},
        {key: 5, title:'5'},
        {key: 6, title:'6'},
        {key: 7, title:'7'},
      ],
    1: [{key: 1, title:'1'}],
    2: [
        {key: 1, title:'1'},
        {key: 2, title:'2'},
        {key: 3, title:'3'},
        {key: 4, title:'4'}
      ],
    3: [],
    4: [],
  }
  let arrone= [];
  for (let i = 1; i < 25; i++) {
    arrone.push({
      key: i,
      title: i
    })
  }
  let arrtwo= [];
  for (let i = 1; i < 61; i++) {
    arrtwo.push({
      key: i,
      title: i
    })
  }
  let arr=[];
  for (let i = 1; i < 29; i++) {
    arr.push({
      key: i,
      title: i
    })
  }
  const timecycleData = {
    0: [{key: 1, title:'1'}],
    1: [],
    2: [
        {key: 1, title:i18n.t('星期日')},
        {key: 2, title:i18n.t('星期一')},
        {key: 3, title:i18n.t('星期二')},
        {key: 4, title:i18n.t('星期三')},
        {key: 5, title:i18n.t('星期四')},
        {key: 6, title:i18n.t('星期五')},
        {key: 7, title:i18n.t('星期六')},
       ],
    3: [{key: 1, title:'1'}],
    4: [{key: 1, title:'1'}]
  }
  timecycleData['1'] = arr;
  cycleData['3'] = arrone;
  cycleData['4'] = arrtwo;
  export default {
    name: 'MeterdebuggingcommandsModal',
    components: {
      DetailList,
      DetailListItem,
      areaWindow
    },
    data () {
      return {
        title:this.$t("命令下发"),
        netTypeObj,
        modalWidth:1024,
        visible: false,
        confirmLoading: false,
        formModel: {
          timings: moment(), //校时默认
          valveOperate:'A1', //强制开关阀默认
          startTime: moment('00:00:00','HH:mm:ss'), //起始时间默认
          reportNum:60,  //最大失联次数默认
          reportInterval:120, //错峰间隔默认
          retryNum:3, //重试次数默认
          retryRounds:3,   //重试轮数默认
          mode:'02',  //工作模式默认
          port:10000, //ip端口号默认
          maxFlow:0, //最大流量默认
          hasValve:1, //是否带阀默认
          disturbTime:120, // 干扰持续时间
          disturbIsCloseValve:0, // 干扰后是否关阀
          lowPowerIsCloseValve:0, // 缺电后关阀时间
          startDate:moment(), //读取表的历史数据
          checkContent:'0', //表端自检默认
          clearType:'0', //清除表端故障
          pulseParam:'0.001', //脉冲系数默认
          remainMoney:0, //剩金额默认
        },
        formTaskModel: {},
        timings:{},
        model: {},
        openKeys: ['sub1'],
        commandKey: undefined,
        originalReadCommandList,
        originalWriteCommandList,
        readCommandList: [],   //读命令
        writeCommandList: [], //写命令
        randomnessList,  //控制类型
        workpatternList,  //工作模式
        selfCheckingContentList,  //自检内容
        pulseFactorList,  //脉冲系数
        clearTypeList,  //清除类型
        value: 1,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 },
        },
        periodData,
        cycleData,
        timecycleData,
        tras:[],
        reportedperiod:0,
        cities: cycleData['0'],
        secondcycle: cycleData['0'][0].key,
        timeCities: timecycleData['0'],
        timeSecondcycle: timecycleData['0'][0].key,
        rootSubmenuKeys: ['sub1', 'sub2'],
        maskClosable:false,
        url: {
          sendCommand: '/jeecg-charge/meter/command/addCommand'
        },
        cmd: {
          1:'901f',
          2:'a015',
          3: 'a018',
          4: '904f',
          5: 'a017',
          6: 'a014',
          7: '906f',
          8: '903f', 
          9: '907f',
          10: '90af',
          11: '908f',
          12: '905f',
          13: '909f',
          14: 'a019', 
          15: 'a021', 
          16: 'a022', 
          17: 'a023', 
          18: '90bf', 
          19: 'a020',
          20: '90cf',
          21: '90df', 
          22: '90ef',
          23: '90ff',
          24: 'a024',
          25: 'a025',
        },
        checkedAreaKeys:[],
        halfCheckedAreaKeys: [],
        checkedAreaNameString:"",
        treeData: [],
        checkedAreaNames: [],
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        fileList: [],
        taskModel: {taskName: ''},
      }
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      rules () {
        return {
          newMeterId: [{ required: true, len:14, message: this.$t('请输入正确的表号!') }],
          newKey1: [{ required: true, message: this.$t('请输入运行密匙!') }],
          newKey2: [{ required: true, message: this.$t('请输入运行密匙!') }],
          newKey3: [{ required: true, message: this.$t('请输入运行密匙!') }],
          newKey4: [{ required: true, message: this.$t('请输入运行密匙!') }],
          ip: [{
            required: true,
            pattern: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
            message: this.$t('IP输入有误')
          }],
        }
      },
      taskRules () {
        return {
          taskName:[{ required: true, message: this.$t('请输入任务名称')}], //订单编号
        }
      },
    },
    methods: {
      filterAuth() {
        let permissionList = [];
        let authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");
        console.log(authList)
        for (let auth of authList) {
          if(auth.type != '2') {
            permissionList.push(auth);
          }
        }
        if (permissionList === null || permissionList === "" || permissionList === undefined||permissionList.length<=0) {
          this.readCommandList = []
          this.writeCommandList = []
          return;
        }
        let permissions = [];
        for (let item of permissionList) {
          if(item.type != '2'){
            //update--begin--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU-------
            if(item.action){
              if(item.action.includes(",")){
                let split = item.action.split(",")
                for (let i = 0; i <split.length ; i++) {
                  if(!split[i] ||split[i].length==0){
                    continue;
                  }
                  permissions.push(split[i]);
                }
              }else{
                permissions.push(item.action);
              }
            }
            //update--end--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU------
          }
        }
        console.log(permissions)
        let readCmdList = []
        for(let item of this.originalReadCommandList) {
          if(permissions.includes('oldcommand'+item.key)) {
            readCmdList.push(item)
          }
        }
        this.readCommandList = readCmdList
        let writeCmdList = []
        for(let item of this.originalWriteCommandList) {
          if(permissions.includes('oldcommand'+item.key)) {
            writeCmdList.push(item)
          }
        }
        this.writeCommandList = writeCmdList
      },
      handleClick(e) {
        this.$nextTick(() => {
          if (this.$refs.formModel !==undefined) {
            this.$refs.formModel.clearValidate()
          }
        })
        console.log('click ', e.key);
      },
      moment,
      onChange(time, timeString) {
        console.log(time, timeString);
      },
      edit(record) {
        console.log(record)
        this.filterAuth();
        this.visible = true;
        this.model = Object.assign({}, record);
        this.taskModel = this.$options.data.call(this).taskModel
        //this.formModel.meterId = record.meterId;
        if(this.model.batchType === 1) {
            this.queryAreaTree();
        }
      },
      handleSubmit() {
        const { fileList } = this;
        if(this.model.batchType===1&&this.checkedAreaKeys.length===0) {
          // 按区域批量下发命令
          this.$message.error(this.$t("请先选择区域"))
          return
        }else if(this.model.batchType===2&&(isUndefinedAndNull(this.model.meterIdList)||this.model.meterIdList.length===0)) {
          this.$message.error(this.$t("请先选择表号"))
          return
        }else if(this.model.batchType===3&&fileList.length===0) {
          this.$message.error(this.$t("请先上传excel文件"))
          return
        }
        this.validateTaskAndSubmit()
      },
      validateTaskAndSubmit() {
        this.$refs.taskModal.validate(valid => {
          if(valid) {
            this.validateCommandAndSubmit()
          }
        })
      },
      validateCommandAndSubmit() {
        if(isUndefinedAndNull(this.commandKey)) {
          this.$message.error(this.$t("请先选择命令"))
          return
        }
        this.$refs.formModel.validate(valid => {
          if (valid) {
            this.confirmLoading = true
            this.sendCommand(this.setCommandParams())
          }
        })
      },
      // 校时
      timing(value, dateString) {
        console.log('Selected Time:', value);
        console.log('Formatted Selected Time: ', dateString);
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      handleCancel() {
        this.close()
      },
      close () {
        this.$emit('close');
        this.commandKey = this.$options.data.call(this).commandKey;
        this.formModel = this.$options.data.call(this).formModel;
        this.model = this.$options.data.call(this).model;
        this.$nextTick(()=>{
          if (this.$refs.formModel !== undefined) {
            this.$refs.formModel.resetFields();
          }
        })
        this.visible = false;
        this.openKeys= ['sub1']
      },
      setCommandParams() {
        let params =  {};
        params.meterType = this.model.mtCode;
        //params.meterId = this.formModel.meterId;
        params.cmd = this.cmd[this.commandKey];
        let cmdParam = {};
        if (this.commandKey == 2) {  //校时
          cmdParam.year = this.formModel.timings.format('YYYY');
          cmdParam.month = this.formModel.timings.format('MM');
          cmdParam.day = this.formModel.timings.format('DD');
          cmdParam.hour = this.formModel.timings.format('HH');
          cmdParam.minute = this.formModel.timings.format('mm');
          cmdParam.second = this.formModel.timings.format('ss');
        } if (this.commandKey == 3) {  //写表号
          cmdParam.newMeterId = this.formModel.newMeterId;
        } 
        if (this.commandKey == 5) {   //强制开关阀
          cmdParam.valveOperate = this.formModel.valveOperate;
          // 需要区分具体是那种阀控命令
          params.cmd = params.cmd+'_'+this.formModel.valveOperate;
        } if (this.commandKey == 6) {   //修改运行密匙
          cmdParam.newKey1 = this.formModel.newKey1;
          cmdParam.newKey2 = this.formModel.newKey2;
          cmdParam.newKey3 = this.formModel.newKey3;
          cmdParam.newKey4 = this.formModel.newKey4;
        } if (this.commandKey == 7) {  //配置表的上报参数
        let cycleUnit = {}
          if (this.reportedperiod == 0) {
            cycleUnit = '30'
          } if (this.reportedperiod == 1) {
            cycleUnit = '50'
          } if (this.reportedperiod == 2 && this.timeSecondcycle == 1) {  //周
            cycleUnit = '40'
          } if (this.reportedperiod == 3) {
            cycleUnit = '20'
          } if (this.reportedperiod == 4) {
            cycleUnit = '10'
          }
          console.log(cycleUnit);
          this.cycleUnit = cycleUnit;
          cmdParam.cycleUnit = this.cycleUnit;
          cmdParam.reportCycle = this.secondcycle;
          cmdParam.startDay = this.timeSecondcycle;
          cmdParam.startTime = this.formModel.startTime.format('HH:mm:ss');
          cmdParam.reportNum = this.formModel.reportNum;  //失联次数
          cmdParam.reportInterval = this.formModel.reportInterval;  //错峰间隔
          cmdParam.retryNum = this.formModel.retryNum;  //重试次数
          cmdParam.retryRounds = this.formModel.retryRounds;  //重试轮数
          cmdParam.mode = this.formModel.mode;  //工作模式
        } if (this.commandKey == 9) {  //配置表的网络参数
          cmdParam.ip = this.formModel.ip;
          cmdParam.port = this.formModel.port;
        } if (this.commandKey == 11) {  //配置表工作参数
          cmdParam.maxFlow = this.formModel.maxFlow;
          cmdParam.hasValve = this.formModel.hasValve;
          cmdParam.disturbTime = this.formModel.disturbTime;
          cmdParam.disturbIsCloseValve = this.formModel.disturbIsCloseValve;
          cmdParam.lowPowerIsCloseValve = this.formModel.lowPowerIsCloseValve;
        } if (this.commandKey == 13) {  //读取表的历史数据
          cmdParam.startDate = this.formModel.startDate.format('YYYY-MM-DD');
        } if (this.commandKey == 18) {  //表端自检功能
          cmdParam.checkContent = this.formModel.checkContent;
        } if (this.commandKey == 20) {  //清除表端故障
          cmdParam.clearType = this.formModel.clearType;
        } if (this.commandKey == 21) {  //模块初始化配置
          cmdParam.meterData = this.formModel.meterData;
          cmdParam.pulseParam = this.formModel.pulseParam;
          cmdParam.remainMoney = this.formModel.remainMoney;
        } 
        params.cmdParam = JSON.stringify(cmdParam);
        return params
      },
      // 协议下发命令
      sendCommand(params) {
        params = Object.assign(params, this.taskModel);
        let formData = new FormData();
        formData = paramsToFormData(params);
        if(this.model.batchType===1) {
          // 按区域批量下发命令
          if(this.checkedAreaKeys.length===0) {
            this.$message.error(this.$t("请先选择区域"))
              return
          }
          formData.append('areaIdList', [...this.checkedAreaKeys].join(","))
          formData.set('taskName',this.taskModel.taskName+this.$t('(按区域)'))
        }else if(this.model.batchType===2) {
          formData.append('meterIdList',this.model.meterIdList)
          formData.set('taskName',this.taskModel.taskName+this.$t('(按表号)'))
        }else if(this.model.batchType===3) {
          const { fileList } = this;
          if(fileList.length==0) {
            this.$message.error(this.$t("请先上传excel文件"))
            return
          }
          fileList.forEach((file) => {
            formData.append('file', file);
          });
          formData.set('taskName',this.taskModel.taskName+this.$t('(按Excel)'))
        }
        this.handleUpload(formData)
      },
      handleUpload(params) {
        this.confirmLoading = true
        postAction(this.url.sendCommand, params).then((res) => {
          this.confirmLoading = false
          if(res.success){
            this.$message.success(this.$t("命令添加成功,请至【命令队列--命令任务列表】去查看结果"))
            this.$emit('ok')
            this.close()
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      // hasValveChange(value){
      //   if (value==0) {
      //     this.formModel.disturbIsCloseValve = 0
      //   } 
      //   // else {
      //   //   this.formModel.disturbIsCloseValve = 1
      //   // }
      //   console.log(value);
      // },
      onOpenChange(openKeys) {
        const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.openKeys = openKeys;
        } else {
          this.openKeys = latestOpenKey ? [latestOpenKey] : [];
        }
      },
      handleperiodChange(value) {
        this.cities = cycleData[value];
        this.secondcycle = cycleData[value][0].key;
        this.timeCities = timecycleData[value];
        this.timeSecondcycle = this.timeCities[0].key;
        console.log(`selected ${value}`);
      },
      handleChange(value) {
        console.log(value); 
      },
      handleChangetime(value) {
        this.timeSecondcycle = value
        console.log(this.timeSecondcycle);
      },
      getCurrentData(){
        return new Date().toLocaleDateString();
      },
      onSearchArea(){
        this.$refs.areaWindow.add(this.checkedAreaKeys,this.halfCheckedAreaKeys,this.treeData,this.checkedAreaNames,this.userId);
      },
      modalAreaFormOk (formData) {
        this.checkedAreaNames = formData.areaNameList;
        this.checkedAreaNameString = this.checkedAreaNames.join(",");
        this.checkedAreaKeys = formData.checkedKeys;
        this.halfCheckedAreaKeys = formData.halfCheckedKeys;
      },
      queryAreaTree(){
        queryAreaTreeList().then((res)=>{
          // 过滤出 leaf node 即可，即选中的
          // Tree组件中checkStrictly默认为false的时候，选中子节点，父节点会自动设置选中或半选中
          // 保存 checkedKeys 以及 halfCheckedKeys 以便于未做任何操作时提交表单数据
          if(res.success){
            this.treeData = res.result;
          }
        })
      },
      convertTreeListToKeyLeafPairs(treeList, keyLeafPair = []) {
        for(const {key, leaf, children} of treeList) {
          keyLeafPair.push({key, leaf})
          if(children && children.length > 0) {
            this.convertTreeListToKeyLeafPairs(children, keyLeafPair)
          }
        }
        return keyLeafPair;
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        let fileName = file.name;
        let fileType = fileName.substring(fileName.lastIndexOf("."),fileName.length);
        if(fileType!='.xls') {
            this.$message.error(this.$t("只支持.xls格式文件！"))
            return false;
        }else{
          this.fileList = [file];
          return false;
        }
      },
    }
  }
</script>

<style scoped>
.ant-row{
  margin-top: 8px;
}
.ant-form-item{
  margin-bottom: 8px;
}
.detail-list >>> .content{
  line-height: normal;
}
.character {
 margin: 10px;
 margin-left: 50px;
 font-size: 15px;
}
.form-contain{
    max-height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
    color: rgba(24,144,255,0.85);
    font-size: 16px;
}
</style>